// Used in the patient lookup workflow to determine the next step.
export enum PatientLookUpStep {
  CREATE = "CREATE",
  NOT_FOUND = "NOT_FOUND",
  UPDATE = "UPDATE",
  UPDATE_MANUAL = "UPDATE_MANUAL",
}

// Used in the doc routing workflow to determine how to upload the document
export enum DocRoutingStrategy {
  EMAIL = "email",
  EHR = "ehr",
  FAX = "fax",
  CLOUD_CRUISE = "cloud_cruise",
  MANUAL = "manual",
  SFTP = "sftp",
}

// Used in the referral workflow to determine how to process the referral
export enum ReferralRoutingStrategy {
  CLOUD_CRUISE = "cloud_cruise",
  EMAIL_ONLY_NO_PATIENT_CREATION = "email_only_no_patient_creation",
  EHR = "ehr",
  EHR_AND_CLOUDCRUISE = "ehr_and_cloudcruise",
  EHR_AND_DOCUMENT_UPLOAD = "ehr_and_document_upload",
  EHR_AND_DOCUMENT_UPLOAD_AND_EMAIL = "ehr_and_document_upload_and_email",
}

// CloudCruise event types
export enum CloudCruiseEventType {
  EXECUTION_SUCCESS = "execution.success",
  EXECUTION_FAILED = "execution.failed",
  SCREENSHOT_UPLOADED = "screenshot.uploaded",
  EXECUTION_STOPPED = "execution.stopped",
}

/**
 * Default filename for documents when downloading
 */
export const DEFAULT_FILENAME = "document.pdf";

// mapping of field to friendly name
export const FIELD_TO_FRIENDLY_NAME = {
  // Patient fields
  "patient.givenName": "Patient First Name",
  "patient.familyName": "Patient Last Name",
  "patient.middleName": "Patient Middle Name",
  "patient.preferredName": "Patient Preferred Name",
  "patient.prefix": "Patient Prefix",
  "patient.suffix": "Patient Suffix",
  "patient.dateOfBirth": "Patient Date of Birth",
  "patient.gender": "Patient Gender",
  "patient.ethnicity": "Patient Ethnicity",
  "patient.language": "Patient Language",
  "patient.race": "Patient Race",
  "patient.homePhoneNumber": "Patient Home Phone",
  "patient.workPhoneNumber": "Patient Work Phone",
  "patient.faxPhoneNumber": "Patient Fax Phone",
  "patient.mobilePhoneNumber": "Patient Mobile Phone",
  "patient.personalEmail": "Patient Personal Email",
  "patient.workEmail": "Patient Work Email",
  "patient.homeAddress": "Patient Home Address",
  "patient.homeAddress.line1": "Patient Home Address Line 1",
  "patient.homeAddress.line2": "Patient Home Address Line 2",
  "patient.homeAddress.city": "Patient Home Address City",
  "patient.homeAddress.district": "Patient Home Address District",
  "patient.homeAddress.state": "Patient Home Address State",
  "patient.homeAddress.postalCode": "Patient Home Address Postal Code",
  "patient.homeAddress.country": "Patient Home Address Country",
  "patient.workAddress": "Patient Work Address",
  "patient.workAddress.line1": "Patient Work Address Line 1",
  "patient.workAddress.line2": "Patient Work Address Line 2",
  "patient.workAddress.city": "Patient Work Address City",
  "patient.workAddress.district": "Patient Work Address District",
  "patient.workAddress.state": "Patient Work Address State",
  "patient.workAddress.postalCode": "Patient Work Address Postal Code",
  "patient.workAddress.country": "Patient Work Address Country",

  // Provider fields
  "npiNumber": "NPI number",
  "givenName": "First name",
  "familyName": "Family name",
  "middleName": "Middle name",
  "preferredName": "Preferred name",
  "specialty": "Specialty",

  // Coverage
  "payer": "Payer",
  "subscriberId": "Subscriber ID",
  "subscriberGivenName": "Subscriber first name",
  "subscriberFamilyName": "Subscriber last name",
  "groupNumber": "Group number",
  "effectiveDate": "Effective date",
  "expirationDate": "Expiration date",

  // Referring Provider fields
  "referringProvider": "Referring Provider",

  // Receiving Provider fields
  "receivingProvider": "Receiving Provider",

  // Primary Care Provider fields
  "primaryCareProvider": "Primary Care Provider",

  // Referring Location fields
  "referringLocation": "Referring Location Address",
  "referringLocation.id": "Missing ID. Please select a location from the dropdown.",

  // Receiving Location fields
  "receivingLocation": "Receiving Location Address",
  "receivingLocation.id": "Missing ID. Please select a location from the dropdown.",

  // Primary Coverage fields
  "primaryCoverage": "Primary Coverage",

  // Secondary Coverage fields
  "secondaryCoverage": "Secondary Coverage",

  // Referral fields
  "dateOfReferral": "Date of Referral",
  "clinicCallReason": "Clinic Call Reason",
  "reasonForReferral": "Reason for Referral",
  "reasonForVisit": "Reason for Visit",
  "receivingDepartment": "Receiving Department",
  "serviceLine": "Service Line",
  "leadSource": "Lead Source",
  "diagnosisCodeType": "Diagnosis Code Type",
  "diagnosisList": "Diagnosis List",
  "schedulingPriority": "Scheduling Priority",
  "containsCptCode": "Contains CPT Code",
  "dateReceived": "Date Received",
  "dateOfDocument": "Date of Document",

  // Prior Authorization fields
  "requestId": "Request ID",
  "authorizationType": "Authorization Type",
  "authorizationStatus": "Authorization Status",
  "authorizationFor": "Authorization For",
  "visitCategory": "Visit Category",
  "commonProcedureTerminologyList": "Common Procedure Terminology List",
  "startDate": "Start Date",
  "endDate": "End Date",
  "numberOfServices": "Number of Services",
  "procedure": "Procedure",
  "medicationName": "Medication Name",
};
